import { useEffect } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { useAuth } from "../context/AuthContext.jsx";
import { shortOrderId } from "../api/client.js";
import Seo from "../components/Seo.jsx";

export default function OrderSuccess() {
  const [params] = useSearchParams();
  const { user, refreshOrders } = useAuth();
  const id = params.get("id");

  // Landing here always means the order state just changed (placed, or just
  // paid) — refetch so "My orders" reflects it without needing a manual reload.
  useEffect(() => {
    if (user) void refreshOrders();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user, id]);

  return (
    <section className="section">
      <Seo title="Order Confirmed" path="/order-success" noindex />
      <div className="container">
        <div className="osx">
          <div className="osx__check">
            <svg viewBox="0 0 24 24" width="34" height="34" fill="none" stroke="currentColor" strokeWidth="2.6" strokeLinecap="round" strokeLinejoin="round">
              <path d="M20 6 9 17l-5-5" />
            </svg>
          </div>

          <h1 className="osx__title">Order placed successfully</h1>
          <p className="osx__lead">
            Thank you for your order. We&apos;ve received it and will confirm availability
            and your delivery slot shortly.
          </p>

          {id && (
            <div className="osx__ref">
              <span>Order number</span>
              <strong>{shortOrderId(id)}</strong>
            </div>
          )}

          <ol className="osx__steps">
            <li>
              <span className="osx__step-ic">✅</span>
              <div><strong>Order received</strong><small>We&apos;ve got your order details.</small></div>
            </li>
            <li>
              <span className="osx__step-ic">📦</span>
              <div><strong>Stock & slot confirmed</strong><small>We&apos;ll check availability and your delivery slot.</small></div>
            </li>
            <li>
              <span className="osx__step-ic">🚚</span>
              <div><strong>Farm-fresh delivery</strong><small>Delivered direct from our Andhra farm.</small></div>
            </li>
          </ol>

          <div className="osx__actions">
            {user ? (
              <Link to="/account" className="btn btn--primary btn--lg">View my orders</Link>
            ) : (
              <Link to="/signup" className="btn btn--primary btn--lg">Create an account</Link>
            )}
            <Link to="/products" className="btn btn--ghost btn--lg">Keep shopping</Link>
          </div>
        </div>
      </div>
    </section>
  );
}
